import { FC } from 'react'
import { useSelector } from 'react-redux'
import { ArticleStandard } from '../../article/components/ArticleStandard'
import { selectAllArticles } from '../../article/data/articleSlice'
import { selectArticlesPageHeading } from '../applicationSlice'
import { PageHeading } from '../styled/PageHeading'

const TrendingArticles: FC = () => {
    const articles = useSelector(selectAllArticles)
    const heading = useSelector(selectArticlesPageHeading)

    return (
        <>
            <PageHeading>{heading}</PageHeading>
            {articles.map(article => {
                return <ArticleStandard key={article.id} article={article} />
            })}
        </>
    )
}

export default TrendingArticles
